const question1 = {
    'question': 'Czym jest terapia systemowa?',
    'answer': 'Terapia systemowa to jeden z nurtów psychoterapii. Od innych nurtów psychoterapeutycznych odróżnia się tym, że nie traktuje pacjenta w sposób jednostkowy, nie skupia uwagi wyłącznie na nim, ale bazuje na systemie. System definiuje jako coś większego, spójna całość. Psychoterapia systemowa koncentruje się na systemie, w którym dany pacjent funkcjonuje na co dzień. Najczęściej spotykanym systemem jest rodzina.',
}

export default question1;